import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';

import searchIcon from '../../../images/search-icon.svg';

export const Wrapper = styled.div`
  width: 100%;
  height: 60px;
  position: relative;
  z-index: 5;
  &.main-menu {
    height: 35px;
  }

  &.main-menu {
    display: block;
    margin: 40px 0;
  }

  &.drawer {
    width: 500px;
    margin: 0 auto;
  }
`;

export const Form = styled.form`
  position: relative;
  display: flex;
  justify-content: center;
  &.header {
    justify-content: flex-end;
  }

  &.center {
    justify-content: center;
  }
`;

export const Submit = styled.button`
  color: transparent;
  border-radius: 30px;
  position: absolute;
  left: 3.75%;
  height: 35px;
  width: 35px;

  ${Form}.main-menu &,
  ${Form}.drawer & {
    height: 20px;
    width: 20px;
  }

  @media only screen and (min-width: 916px) {
    display: ${({ open }) => (open ? 'block' : 'none')};
  }
`;

export const SearchContainer = styled.div`
  width: 100%;
  max-width: 500px;
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  ${Form}.main-menu & {
    margin: 0 2rem;
  }

  fieldset {
    label {
      font-size: 1rem;
      font-weight: ${themeGet('fontWeights.normal')};
      clip: rect(0 0 0 0);
      clip-path: inset(50%);
      height: 1px;
      overflow: hidden;
      position: absolute;
      white-space: nowrap;
      width: 1px;
    }
  }

  .search-form {
    width: 100%;
    max-width: 500px;
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`;

export const Search = styled.input.attrs(() => ({
  type: 'search',
}))`
  border-radius: 30px;
  border: 1px solid ${themeGet('colors.cta-border-grey')};
  background-image: url(${searchIcon});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
  color: transparent;
  width: 100%;
  transition: all 0.5s ease-in-out;
  /* outline: none; */
  cursor: pointer;
  width: 60px;
  max-width: 500px;
  height: 60px;
  padding: 10px;

  @-moz-document url-prefix() {
    padding: 20px;
  }

  &::placeholder {
    color: transparent;
    transition: all 0.75s;
    font-size: 1rem;
    line-height: 2.33;
    font-weight: ${themeGet('fontWeights.normal')};
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    overflow: visible;
  }

  &.is-open {
    padding-left: 45px;
    color: ${themeGet('colors.main-text')};
    width: 100%;
    line-height: 2.33;
    background-position: 20px;
    cursor: auto;
    &::placeholder {
      color: ${themeGet('colors.secondary-text')};
    }
  }

  &.main-menu {
    height: 35px;
    width: 35px;
    max-width: 100%;
    border: solid 1px ${themeGet('colors.border-grey')};
    background-color: ${themeGet('colors.light-grey')};
    &::placeholder {
      font-size: 16px;
      line-height: 1;
    }
    &.is-open,
    &:focus {
      color: ${themeGet('colors.main-text')};
      background-color: ${themeGet('colors.light-grey')};
      width: 100%;
    }
  }

  &.drawer {
    border: none;
    background-image: url(${searchIcon});
    background-color: ${themeGet('colors.pc-dark-pink')};
    &.is-open,
    &:focus,
    &:hover {
      padding-left: 45px;
      color: ${themeGet('colors.main-text')};
      background-image: url(${searchIcon});
      background-color: ${themeGet('colors.pc-dark-pink')};
      outline: none;
      width: 100%;
    }
  }
`;

export const Overlay = styled.div`
  position: fixed;
  pointer-events: all;
  height: 100vh;
  width: 100vw;
  left: 0;
  top: 0;
  display: ${({ open }) => (open ? 'block' : 'none')};
  color: ${({ open }) => (open ? 'red' : 'blue')};
`;
